import { styled } from '@mui/material';

import { ReactNode } from 'react';

import background from './background.svg';
import { RoundIcon } from '../RoundIcon';

const BackgroundPatternContainer = styled('div')({
  position: 'relative',
});

const Background = styled('img')({
  position: 'absolute',
  objectFit: 'cover',
  transform: 'translate(-50%, -50%)',
  left: '50%',
  top: '50%',
  zIndex: -1,
});

export type IconWithBackgroundPatternProps = {
  icon: ReactNode;
};

export const IconWithBackgroundPattern = ({
  icon,
}: IconWithBackgroundPatternProps) => {
  return (
    <BackgroundPatternContainer>
      <Background src={background} alt="Background" />
      <RoundIcon icon={icon} />
    </BackgroundPatternContainer>
  );
};
